import { Ikon } from '../status/Ikon.tsx';

/**
 * Bryter: role=switch. Tilstanden bæres av knottens POSISJON og et hakemerke i knotten
 * når den er på — ikon og form, aldri farge alene (DD-08 presisert 2026-09-19, kjente
 * feil-konsept v0.1, P1). Etiketten er bryterens navn, og det er hele etiketten:
 * teksten «På»/«Av» ved siden av er tatt ut, fordi raden sa tilstanden tre ganger (F8).
 * Dette er den DELTE bryteren — Innstillinger og Webhooks bruker den samme.
 *
 * En låst bryter har alltid en synlig grunn UNDER seg, koblet med `aria-describedby` —
 * ikke bare i `title` (DD-18, ux-flow-architect «Forklarte låser»; UX-gjennomgangen
 * 2026-09-14, B1: «Hardt av fordi brukerne kan være mindreårige …» sto kun i tooltip, og
 * etiketten lå i `text-disabled`, under AA). Etiketten forblir lesbar; bare knotten dempes.
 * `felt` er kontraktens feltnavn, vist lite under etiketten for den som leser kontrakten —
 * etiketten selv sier hva bryteren betyr (DD-50).
 */
export function Bryter({ label, felt, ikon, paa, grunn, onChange, testid, skjultEtikett }: { label: string; felt?: string; ikon?: string; paa: boolean; grunn?: string | null; onChange: (v: boolean) => void; testid?: string; skjultEtikett?: boolean }) {
  const laast = Boolean(grunn);
  const grunnId = `bryter-grunn-${(testid ?? label).replace(/\W+/g, '-')}`;
  return (
    <span className="panel-bryter-med-grunn">
      <button
        type="button"
        role="switch"
        aria-checked={paa}
        aria-disabled={laast || undefined}
        aria-describedby={laast ? grunnId : undefined}
        // Står bryteren ALENE i en rads verdikolonne, er radnavnet etiketten — navnet skal
        // ikke stå to ganger (DD-67: samme opplysning ett sted).
        aria-label={skjultEtikett ? label : undefined}
        title={label}
        className={`panel-bryter${laast ? ' panel-bryter-laast' : ''}`}
        onClick={laast ? undefined : () => onChange(!paa)}
        data-testid={testid}
      >
        <span aria-hidden="true" className={`panel-bryter-spor${paa ? ' panel-bryter-paa' : ''}`}>
          <span className="panel-bryter-knott">{paa ? <Ikon navn="checkmark-outline" /> : null}</span>
        </span>
        {ikon && !skjultEtikett ? <Ikon navn={ikon} /> : null}
        {skjultEtikett ? null : (
          <span className="panel-bryter-etikett">
            {label}
            {felt ? <span className="panel-bryter-felt">{felt}</span> : null}
          </span>
        )}
      </button>
      {laast ? (
        <span id={grunnId} className="panel-grunn" data-testid={testid ? `${testid}-grunn` : undefined}>
          <Ikon navn="lock-closed-outline" /> {grunn}
        </span>
      ) : null}
    </span>
  );
}
